import * as React from 'react'
import type { SVGProps } from 'react'
function SvgGruneStadtVersiegelteFlache253727075341(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 241.1 227.7"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M212.1,210.5c-0.8-8.5-6.9-15.5-15.3-17.3l-26-5.6l-30.3-17.4c-4.6-2.7-9.9-4-15.2-3.8l-24.4,0.8V6h60.8v48.8 c0,1.7,1.3,3,3,3s3-1.3,3-3V3c0-1.7-1.3-3-3-3H98c-1.7,0-3,1.3-3,3v164.4l-10.3,0.3c-1,0-2,0.1-3,0.3V70.6c0-1.2-0.6-2.2-1.7-2.7 c-1-0.5-2.3-0.4-3.2,0.3l-57.1,45.2c-0.7,0.6-1.1,1.4-1.1,2.4v69.7H3c-1.7,0-3,1.3-3,3s1.3,3,3,3h49.5c-1.5,3.4-2.3,7.2-2.3,11 v10.2c0,6.2,4.4,11.6,10.4,12.8l10.5,2.2c0.2,0,0.4,0.1,0.6,0.1h128.9c3.3,0,6.5-1.4,8.8-3.9c2.3-2.5,3.4-5.8,3.1-9.1L212.1,210.5z  M75.7,169.5c-3.8,1.4-7.3,3.6-10.3,6.6l-7.2,7.1c-0.7,0.7-1.4,1.5-2,2.3H24.5v-68.2l51.1-40.4V169.5z M56.2,202.4 c0-5.6,2.3-11,6.2-15l7.2-7.1c4.1-4.1,9.5-6.4,15.3-6.6l40.7-1.3c0.2,0,0.5,0,0.7,0c4,0,7.9,1,11.3,3l30.7,17.6 c0.3,0.2,0.6,0.3,0.9,0.3l26.4,5.7c5.8,1.2,10,6,10.6,11.9l0.4,4.2c0.1,1.7-0.4,3.3-1.5,4.5c-1.1,1.2-2.7,1.9-4.4,1.9H71.9l0,0 l-10.1-2.1c-3.3-0.7-5.7-3.6-5.7-7V202.4z" />
        <path d="M238.1,185.4h-15.5V72.5c0-1.7-1.3-3-3-3h-73.3c-1.7,0-3,1.3-3,3v86.7c0,1.7,1.3,3,3,3s3-1.3,3-3V75.5h67.3v112.9 c0,1.7,1.3,3,3,3h18.5c1.7,0,3-1.3,3-3S239.8,185.4,238.1,185.4z" />
        <path d="M161.4,104.4h43c1.7,0,3-1.3,3-3s-1.3-3-3-3h-43c-1.7,0-3,1.3-3,3S159.8,104.4,161.4,104.4z" />
        <path d="M161.4,121.4h43c1.7,0,3-1.3,3-3s-1.3-3-3-3h-43c-1.7,0-3,1.3-3,3S159.8,121.4,161.4,121.4z" />
        <path d="M161.4,138.4h43c1.7,0,3-1.3,3-3s-1.3-3-3-3h-43c-1.7,0-3,1.3-3,3S159.8,138.4,161.4,138.4z" />
      </g>
    </svg>
  )
}
export default SvgGruneStadtVersiegelteFlache253727075341
